document.addEventListener("DOMContentLoaded", () => {

    // Card slider 
    document.querySelectorAll('.card-slider').forEach(function(wrapper) {
        var cardSwiper = new Swiper(wrapper.querySelector('.cpap-card-swiper'), {
            slidesPerView: 4,        
            spaceBetween: 20,        
            loop: false,             
            navigation: {
                nextEl: wrapper.querySelector('.swiper-button-next'),
                prevEl: wrapper.querySelector('.swiper-button-prev')
            },
            breakpoints: {
                320:  { 
                    slidesPerView: 'auto', 
                    spaceBetween: 12
                },
                1200: { slidesPerView: 4, spaceBetween: 32 }
            }
        });
    });
    
     // Card slider 
    document.querySelectorAll('.icon-box-list__carousel').forEach(function(wrapper) {
        var cardSwiper = new Swiper(wrapper.querySelector('.cpap-icon-box-swiper'), {
            slidesPerView: 3,        
            spaceBetween: 20,        
            loop: true,             
            navigation: {
                nextEl: wrapper.querySelector('.swiper-button-next'),
                prevEl: wrapper.querySelector('.swiper-button-prev')
            },
            breakpoints: {
                320:  { 
                    slidesPerView: 1, 
                    spaceBetween: 20
                },
                640:  { slidesPerView: 2 },
                1024: { 
                    slidesPerView: 3,
                    spaceBetween: 20
                },
            }
        });
    });

    // Doctor slider 
    document.querySelectorAll('.doctor-slider').forEach(function(wrapper) {
        var cardSwiper = new Swiper(wrapper.querySelector('.cpap-doctor-swiper'), {
            slidesPerView: 4,        
            spaceBetween: 20,        
            loop: true,             
            navigation: false,

            breakpoints: {
                320:  { slidesPerView: 1 },
                640:  { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1200: { slidesPerView: 4 }
            }
        });
    });

    // Thumbnail Slider
    document.querySelectorAll('.thumbnail-slider-section').forEach(function(wrapper) {
        const mainEl = wrapper.querySelector('.swiper-main');
        const thumbsEl = wrapper.querySelector('.swiper-thumbs');

        if (!mainEl || !thumbsEl) return;

        // Thumbs swiper
        const thumbsSwiper = new Swiper(thumbsEl, {
            slidesPerView: 5,
            spaceBetween: 20,
            watchSlidesProgress: true,
            freeMode: true,
            breakpoints: {
                0:   { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
                1280: { slidesPerView: 5 }
            }
        });

        // Main swiper linked to thumbs
        const mainSwiper = new Swiper(mainEl, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            thumbs: {
                swiper: thumbsSwiper
            }
        });
    });
    
    // Show/hide mega menu on mobile
    document.querySelectorAll('.main-header .mobile-header-actions .menu-toggle-btn').forEach(function(button) {
        button.addEventListener('click',function(e){
            e.preventDefault();
            const mega_memu_st = document.querySelector('.shopify-section:has(.cpap-mega-menu-section)');
            if (mega_memu_st) {
                mega_memu_st.classList.toggle('show');
            }
        });
    });

    // show/hide submenu on mobile
    document.querySelectorAll('.menu-list > .menu-item > a').forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            const menuItem = link.closest('.menu-item');
            if (!menuItem) return;

            const dropdown = menuItem.querySelector('.dropdown');
            if (!dropdown) return;

            dropdown.classList.toggle('show');
        });
    });
    document.querySelectorAll('.cpap-mega-menu-section .close-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();

            const section = btn.closest('.shopify-section');
            if (section) {
            section.classList.remove('show');
            }
        });
    });
});